import { render, staticRenderFns } from "./PointTransactions.vue?vue&type=template&id=437a45fe&"
import script from "./PointTransactions.vue?vue&type=script&lang=js&"
export * from "./PointTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports